import {
  Component,
  OnDestroy,
  AfterContentInit,
  Renderer2,
  OnInit,
  Output,
  EventEmitter,
  ViewEncapsulation,
  Input
} from '@angular/core';
import { FnMenuItemState } from '../models/fn-menu.state';
import { Subscription, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { FnMenuDataService } from '../service/fn-menu-data.service';
import { FnMenuEventService } from '../service/fn-menu-event.service';

@Component({
  selector: 'fn-menu-sidebar',
  templateUrl: 'fn-menu-sidebar.component.html',
  encapsulation: ViewEncapsulation.None
})
export class FnMenuSidebarComponent
  implements OnDestroy, AfterContentInit, OnInit {
  @Output() readonly fnClick = new EventEmitter<string>();

  private subscription = new Subscription();

  private destroy$: Subject<boolean> = new Subject<boolean>();
  sidebarHeight = '';
  @Input() isMenuLoded:boolean;
  private menuItemMap: object|any;
  public menuData: FnMenuItemState;

  constructor(
    private fnMenuDataSvcs: FnMenuDataService,
    private fnMenuService: FnMenuEventService,
    private renderer: Renderer2,
    private router: Router
  ) {
    // this.subscribeMenuData();
  }

  private subscribeMenuData() {
    this.menuData = this.fnMenuDataSvcs.getMenuData();
    this.isMenuLoded = true;
    this.menuItemMap = this.fnMenuDataSvcs.getMenuItemMap();
  }

  private navigateToUrl(url: string) {
    // if (url === this.SUB_MENU_LANDING_URL) {
    //   url += '/submenu';
    // }
    this.router.navigateByUrl(url);
  }

	private menuClickSubscriber() {
		this.fnMenuService.menuItemClick$
			.pipe(takeUntil(this.destroy$))
			.subscribe(urlObj => {
				this.fnMenuDataSvcs.setActiveMenuId(urlObj.menuId);
				this.fnClick.emit(urlObj.menuId);
				// this.menuItemMap.get(menuId)
				// todo routing help
				if (urlObj.isChangeUrl) {
					this.navigateToUrl(this.menuItemMap[urlObj.menuId].detail.url);
				}
			});
	}

  ngOnInit(): void {
    this.menuData = this.fnMenuDataSvcs.getMenuData();
    this.menuItemMap = this.fnMenuDataSvcs.getMenuItemMap();
    this.menuClickSubscriber();
    this.calSidebarHeight(); 
  }

  ngAfterContentInit() {
    this.listenWindowResize();
  }

  calSidebarHeight() {
    // this.sidebarHeight = (window.innerHeight -56) + 'px';
  }

  listenWindowResize() {
    this.subscription.add(
      this.renderer.listen(window, 'resize', () => {
        // TODO resizeing
        this.calSidebarHeight();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
